import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { initLogger } from 'tofe-core';
import { LanguageService } from 'tofe-language';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'tofe';

  constructor() {
    const languageService = inject(LanguageService);

    initLogger();
    languageService.init().subscribe();

    inject(Router)
      .events.pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        // defer to next tick so the routed component has time to render
        setTimeout(() => {
          const main = document.querySelector('main');
          if (main) {
            main.setAttribute('tabindex', '-1');
            main.focus({ preventScroll: true });
          }
        });
      });
  }
}
